module.exports = __webpack_public_path__ + "static/media/OvalStart.50309507.png";